import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  IOTPredictive,
  IOTSupply,
  IOTRealTime,
  IOTConnected,
  IOTVehicles,
  IOTHomes,
} from "../../../app-constants";

function Iotsolutions() {
  return (
    <section className="iot_solutions p-100 tekrevol_dark_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h3 className="h3_head">
              Our IoT-based Solutions <span>Across Diverse Industries</span>
            </h3>
            <p>
              We follow our flagship, agile-based process to develop, integrate,
              implement and deploy artificial intelligence solutions. Our
              process is simple, structured and guarantees development ROI
              because each step is productive and yields game-changing
              deliverables.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTPredictive}</div>
              <div className="iot-solution_content">
                <h5>Predictive Maintenance</h5>
                <p>
                  Real-time monitoring of products and equipment through
                  implementing predictive maintenance also helps pinpoint issues
                  ahead of time and detect failure modes. This process also
                  helps in concrete warranty confirmation and warranty
                  infringement as well to make your equipment more long-lasting
                  and durable.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTSupply}</div>
              <div className="iot-solution_content">
                <h5>Supply Chain Management</h5>
                <p>
                  In supply chain management, IoT solutions track the balance of
                  the products and make notifications about the stock’s
                  depletion. They also help moderate the climate within the
                  warehouse and ensure robotics-based order picking; they
                  regulate transportation climate control to enhance product
                  quality.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTRealTime}</div>
              <div className="iot-solution_content">
                <h5>Real-Time Asset Tracking</h5>
                <p>
                  Assets can be tracked not only by their actual position and
                  their changes but also by maps and geofencing for indoors and
                  outdoors. This system consists of asset tracking analytics &
                  reporting, asset management & Operational efficiency at its
                  core.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTConnected}</div>
              <div className="iot-solution_content">
                <h5>Connected Products</h5>
                <p>
                  Affiliated products include smart industrial objects with
                  control applications and sophisticated customer items with a
                  central hub to control smart devices, control, and user
                  applications. It also includes more basic smart consumer
                  goods, such as home devices and exercise equipment, which
                  offer users improved control and integration.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTVehicles}</div>
              <div className="iot-solution_content">
                <h5>Connected Vehicles</h5>
                <p>
                  Connected vehicles use IoT to evaluate environmental
                  conditions to deliver and store perishable goods, document
                  drivers’ actions, and determine routes. They also include
                  adaptive cruise control, dispatch management, and vehicle
                  maintenance control, so logistics and transportation are safe
                  and efficient.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="iot_solution_box">
              <div className="iot_solution_svg">{IOTHomes}</div>
              <div className="iot-solution_content">
                <h5>Smart Homes</h5>
                <p>
                  In smart homes, IoT is applied in the measurement of the
                  indoor environment and determination of when and how to
                  regulate, the use of energy. They include cameras and motion
                  detectors for home security and management of power usage by
                  the homeowners.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Iotsolutions;
